import { render, staticRenderFns } from "./techHd.vue?vue&type=template&id=6be79956&scoped=true&"
import script from "./techHd.vue?vue&type=script&lang=js&"
export * from "./techHd.vue?vue&type=script&lang=js&"
import style0 from "./techHd.vue?vue&type=style&index=0&id=6be79956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be79956",
  null
  
)

export default component.exports